import {ESwitchType} from '../types/project.type'

/**
 * General Project Sizes
 */
/**
 * Soft cap (inclusive days) for the list "period" date-range view (activities + notices).
 * One year. Same name and value as the API's MAX_LIST_PERIOD_DAYS (models/schemas/_helpers.ts) — keep the two in sync.
 */
const MAX_LIST_PERIOD_DAYS = 365

/**
 * Hard cap (inclusive days) of the reports matrix: one column per date, so a
 * longer period is shown from its first day only. Same name and value as the
 * API's MAX_REPORT_RANGE_DAYS (models/schemas/_helpers.ts) — keep in sync.
 */
const MAX_REPORT_RANGE_DAYS = 31

const GENERAL_MAIN_MENU_FULL_WIDTH = 250
const GENERAL_MAIN_MENU_MIN_WIDTH = 65
const PROJECT_LEFT_MENU_WIDTH = 68

/**
 * WorkView Sizes
 */
const WIDTH_TEXT_VOIE = 14
const WIDTH_SIMPLE_AIGUILLAGE = 14
const WIDTH_DOUBLE_AIGUILLAGE = 28
const WIDTH_ACCESS = 42
const HEIGHT_ACCESS = 33.5
const LEFT_PANNEL_WIDTH = 185

/**
 * GeographicZonesContainer Sizes
 */
const SECTORS_ZONE_HEIGHT = 27
const SUBSECTORS_ZONE_HEIGHT = 20
const GEO_ZONE_HEIGHT = 16
const PROTECTION_ZONE_HEIGHT = 9
const ACCESS_ZONE_HEIGHT = 20
const PADS_ZONE_HEIGHT = 5

/**
 * Component sizes
 */
const MOVEMENT_HEIGHT = 16

// Devices declarable on a project. STRAIGHT is deliberately absent: a straight
// through-connection is network-scoped and only offered by the referential
// screen, so the project switch form must not list it.
// `labelKey` is dictionary wording: the field's jargon for an orientation
// (Montant / Descendant) is the kind of term a client rewords.
const SWITCH_TYPE = [
  {
    id: ESwitchType.SIMPLE_1,
    labelKey: 'referential:typeUp',
    iconType: 'switchSimple1',
  },
  {
    id: ESwitchType.SIMPLE_2,
    labelKey: 'referential:typeDown',
    iconType: 'switchSimple2',
  },
  {
    id: ESwitchType.DOUBLE,
    labelKey: 'referential:typeCross',
    iconType: 'switchDouble',
  },
]

// Every type a stored row can carry — what a renderer must be able to draw.
const ALL_SWITCH_TYPE = [
  ...SWITCH_TYPE,
  {
    id: ESwitchType.STRAIGHT,
    labelKey: 'referential:typeStraight',
    iconType: 'switchStraight',
  },
]

export {
  MAX_LIST_PERIOD_DAYS,
  MAX_REPORT_RANGE_DAYS,
  GENERAL_MAIN_MENU_FULL_WIDTH,
  GENERAL_MAIN_MENU_MIN_WIDTH,
  PROJECT_LEFT_MENU_WIDTH,
  WIDTH_DOUBLE_AIGUILLAGE,
  WIDTH_SIMPLE_AIGUILLAGE,
  WIDTH_TEXT_VOIE,
  SWITCH_TYPE,
  ALL_SWITCH_TYPE,
  WIDTH_ACCESS,
  HEIGHT_ACCESS,
  LEFT_PANNEL_WIDTH,
  MOVEMENT_HEIGHT,
  SECTORS_ZONE_HEIGHT,
  SUBSECTORS_ZONE_HEIGHT,
  GEO_ZONE_HEIGHT,
  PROTECTION_ZONE_HEIGHT,
  ACCESS_ZONE_HEIGHT,
  PADS_ZONE_HEIGHT,
}
